module.exports = __webpack_public_path__ + "img/sec-10-kb.0cd1fab2.svg";